<template>
   <section class="section">
    <div class="container" style="margin-top: -30px;">
      

      <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ຄວາມເພິ່ງພໍໃຈໂດຍລວມ: <span style="color: red;">{{ overallscorereport[0].OVERALLSCORE }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="overallscoreDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button> 
              </div>
            </div>
          </div>
        </div>
      </div> 
      <div class="columns " v-show="overallscoreSwitch==1" >  
        <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small"  style="width: 30%;">
            <thead>
              <tr>
                <th class="has-text-left " width="10%">
                  #
                </th>
                <th class="has-text-left " width="70%">
                  ຄະແນນ
                </th>
                <th class="has-text-right " width="20%">
                  ຈຳນວນ 
                </th>
              </tr>
            </thead>
            <tbody> 
              <tr
                v-for="(data, index) in overallscorereport"
                :key="data.OVERALLSCORE"
              > 
                <td> {{ index +1 }}</td>
                <td> {{ data.OVERALLSCORE }}</td>
                <td class="has-text-right ">{{ data.COUNTSCORE }}</td>
              </tr>
            </tbody>
            
          </table>
        
          <canvas id="overallscorereport" style="padding-left: 30px;"></canvas>
            
           
      </div>

      <!-- province -->
      <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ແຂວງທີ່ເຂົ້າຮ່ວມຫຼາຍທີ່ສຸດ: <span style="color: red;">{{ provincereport[0].PROVINCENAME }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="provinceDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div> 
      <div class="columns " v-show="provinceSwitch==1" >  
            <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" style="width: 25%;" >
              <thead>
                <tr>
                  <th class="has-text-left " width="10%">
                    #
                  </th>
                  <th class="has-text-left " width="70%">
                    ແຂວງ
                  </th>
                  <th class="has-text-right " width="20%">
                    ຄະແນນ
                  </th>
                </tr>
              </thead>
              <tbody> 
                <tr
                  v-for="(province, index) in provincereport"
                  :key="province.PROVINCENAME"
                > 
                  <td> {{ index +1 }}</td>
                  <td> {{ province.PROVINCENAME }}</td>
                  <td class="has-text-right ">{{ province.COUNTSCORE }}</td>
                </tr>
              </tbody>
              
            </table>
        
            <canvas id="provincereport" style="padding-left: 30px;"></canvas>
            
           
      </div>
      <!--  participate -->

      <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ຈຳນວນຜູ້ສົນໃຈບູ໋ດ: <span style="color: red;">{{ numberofparticipatereport[0].CUSTOMERRANK }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="participateDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="columns " v-show="participateSwitch==1">  
        <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" style="width: 25%;">
          <thead>
            <tr>
              <th class="has-text-left " width="10%">
                #
              </th>
              <th class="has-text-left " width="70%">
                ຈຳນວນຜູ້ສົນໃຈບູ໋ດ
              </th>
              <th class="has-text-right " width="20%">
                ຈຳນວນ
              </th>
            </tr>
          </thead>
          <tbody> 
            <tr
              v-for="(participaterank, index) in numberofparticipatereport"
              :key="participaterank.CUSTOMERRANK"
            > 
              <td> {{ index +1 }}</td>
              <td> {{ participaterank.CUSTOMERRANK }}</td>
              <td class="has-text-right ">{{ participaterank.COUNTRANK }}</td>
            </tr>
          </tbody>
          
        </table>

        <canvas id="numberofparticipatereport" style="padding-left: 30px;"></canvas>
            
           
      </div>

      <!--  duration -->

      <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ຈັດງານ 5 ວັນ: <span style="color: red;">{{ durationreport[0].DURATION }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="durationDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="columns " v-show="durationSwitch==1">  
        <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" style="width: 25%;">
          <thead>
            <tr>
              <th class="has-text-left " width="10%">
                #
              </th>
              <th class="has-text-left " width="70%">
                ຄວາມຮູ້ສຶກ
              </th>
              <th class="has-text-right " width="20%">
                ຈຳນວນ
              </th>
            </tr>
          </thead>
          <tbody> 
            <tr
              v-for="(participaterank, index) in durationreport"
              :key="participaterank.DURATION"
            > 
              <td> {{ index +1 }}</td>
              <td> {{ participaterank.DURATION }}</td>
              <td class="has-text-right ">{{ participaterank.COUNTDURATION }}</td>
            </tr>
          </tbody>
          
        </table>

        <canvas id="durationreport" style="padding-left: 30px;"></canvas>
            
           
      </div>

      <!--  place -->

      <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ສະຖານທີ່ຈັດງານ: <span style="color: red;">{{ placescorereport[0].PLACESCORE }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="placescoreDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="columns " v-show="placescoreSwitch==1">  
        <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" style="width: 25%;">
          <thead>
            <tr>
              <th class="has-text-left " width="10%">
                #
              </th>
              <th class="has-text-left " width="70%">
                ຄະແນນ
              </th>
              <th class="has-text-right " width="20%">
                ຈຳນວນ
              </th>
            </tr>
          </thead>
          <tbody> 
            <tr
              v-for="(participaterank, index) in placescorereport"
              :key="participaterank.PLACESCORE"
            > 
              <td> {{ index +1 }}</td>
              <td> {{ participaterank.PLACESCORE }}</td>
              <td class="has-text-right ">{{ participaterank.COUNTSCORE }}</td>
            </tr>
          </tbody>
          
        </table>

        <canvas id="placescorereport" style="padding-left: 30px;"></canvas>
            
           
      </div>

       <!--  activity -->

       <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ກິດຈະກຳໃນງານ: <span style="color: red;">{{ activityscorereport[0].ACTIVITYSCORE }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="activityscoreDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="columns " v-show="activityscoreSwitch==1">  
        <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" style="width: 25%;">
          <thead>
            <tr>
              <th class="has-text-left " width="10%">
                #
              </th>
              <th class="has-text-left " width="70%">
                ຄະແນນ
              </th>
              <th class="has-text-right " width="20%">
                ຈຳນວນ
              </th>
            </tr>
          </thead>
          <tbody> 
            <tr
              v-for="(participaterank, index) in activityscorereport"
              :key="participaterank.ACTIVITYSCORE"
            > 
              <td> {{ index +1 }}</td>
              <td> {{ participaterank.ACTIVITYSCORE }}</td>
              <td class="has-text-right ">{{ participaterank.COUNTSCORE }}</td>
            </tr>
          </tbody>
          
        </table>

        <canvas id="activityscorereport" style="padding-left: 30px;"></canvas>
            
           
      </div>

      <!--  coordination -->

      <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ການປະສານງານກັບຄະນະຈັດງານ: <span style="color: red;">{{ coordinationscorereport[0].COORDINATIONSCORE }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="coordinationscoreDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="columns " v-show="coordinationscoreSwitch==1">  
        <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" style="width: 25%;">
          <thead>
            <tr>
              <th class="has-text-left " width="10%">
                #
              </th>
              <th class="has-text-left " width="70%">
                ຄະແນນ
              </th>
              <th class="has-text-right " width="20%">
                ຈຳນວນ
              </th>
            </tr>
          </thead>
          <tbody> 
            <tr
              v-for="(participaterank, index) in coordinationscorereport"
              :key="participaterank.COORDINATIONSCORE"
            > 
              <td> {{ index +1 }}</td>
              <td> {{ participaterank.COORDINATIONSCORE }}</td>
              <td class="has-text-right ">{{ participaterank.COUNTSCORE }}</td>
            </tr>
          </tbody>
          
        </table>

        <canvas id="coordinationscorereport" style="padding-left: 30px;"></canvas>
            
           
      </div>

      <!--  budget -->

      <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ງົບປະມານທີ່ໃຊ້ໃນການອອກບູດ: <span style="color: red;">{{ budgetreport[0].BUDGET }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="budgetDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="columns " v-show="budgetSwitch==1">  
        <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" style="width: 25%;">
          <thead>
            <tr>
              <th class="has-text-left " width="10%">
                #
              </th>
              <th class="has-text-left " width="70%">
                ງົບປະມານ
              </th>
              <th class="has-text-right " width="20%">
                ຈຳນວນ
              </th>
            </tr>
          </thead>
          <tbody> 
            <tr
              v-for="(participaterank, index) in budgetreport"
              :key="participaterank.BUDGET"
            > 
              <td> {{ index +1 }}</td>
              <td> {{ participaterank.BUDGET }}</td>
              <td class="has-text-right ">{{ participaterank.COUNTSCORE }}</td>
            </tr>
          </tbody>
          
        </table>

        <canvas id="budgetreport" style="padding-left: 30px;"></canvas>
            
           
      </div>

      <!--  nextevent -->

      <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ປີໜ້າຈະເຂົ້າຮ່ວມງານ Agri Expo ອີກບໍ່?: <span style="color: red;">{{ nexteventreport[0].NEXTEVENT }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="nexteventDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="columns " v-show="nexteventSwitch==1">  
        <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" style="width: 25%;">
          <thead>
            <tr>
              <th class="has-text-left " width="10%">
                #
              </th>
              <th class="has-text-left " width="70%">
                ການເຂົ້າຮ່ວມ
              </th>
              <th class="has-text-right " width="20%">
                ຈຳນວນ
              </th>
            </tr>
          </thead>
          <tbody> 
            <tr
              v-for="(participaterank, index) in nexteventreport"
              :key="participaterank.NEXTEVENT"
            > 
              <td> {{ index +1 }}</td>
              <td> {{ participaterank.NEXTEVENT }}</td>
              <td class="has-text-right ">{{ participaterank.COUNTSCORE }}</td>
            </tr>
          </tbody>
          
        </table>

        <canvas id="nexteventreport" style="padding-left: 30px;"></canvas>
            
           
      </div>
      <!--  nexteventmonth -->

      <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ງານ Agri Expo ປີໜ້າ ຄວນຈັດໃສ່ເດືອນໃດ: <span style="color: red;">{{ nexteventmonthreport[0].NEXTEVENTMONTH }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="nexteventmonthDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="columns " v-show="nexteventmonthSwitch==1">  
        <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" style="width: 25%;">
          <thead>
            <tr>
              <th class="has-text-left " width="10%">
                #
              </th>
              <th class="has-text-left " width="70%">
                ເດືອນ
              </th>
              <th class="has-text-right " width="20%">
                ຈຳນວນ
              </th>
            </tr>
          </thead>
          <tbody> 
            <tr
              v-for="(participaterank, index) in nexteventmonthreport"
              :key="participaterank.NEXTEVENTMONTH"
            > 
              <td> {{ index +1 }}</td>
              <td> {{ participaterank.NEXTEVENTMONTH }}</td>
              <td class="has-text-right ">{{ participaterank.COUNTSCORE }}</td>
            </tr>
          </tbody>
          
        </table>

        <canvas id="nexteventmonthreport" style="padding-left: 30px;"></canvas>
            
           
      </div>

      <!--  nexteventuptodigital -->

      <div class="columns card-container"  style="margin-left: -20px; margin-right: -20px;">  
        <div class="column card-item" >
          <div class="card2" style="padding-left: 10px; padding-right: 10px; ">
            <div class="card-content2 ">
              <div style="margin-bottom: 5px;">
                <b-field>ງານ Agri Expo ປີໜ້າ ຫັນເປັນ Digital ຫູາຍຂຶ້ນ: <span style="color: red;">{{ nexteventuptodigitalreport[0].NEXTEVENTUPTODIGITAL }}</span></b-field>
              </div>
              

              <div style="margin-bottom: 5px;">
                <b-button 
                    class="btn-group-margin"
                    type="is-success" 
                    @click="nexteventuptodigitalDetail()"
                    >  <span > ລາຍລະອຽດ</span>
                </b-button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="columns " v-show="nexteventuptodigitalSwitch==1">  
        <table v-show="1 == 1" class="table is-fullwidth is-narrow is-small" style="width: 25%;">
          <thead>
            <tr>
              <th class="has-text-left " width="10%">
                #
              </th>
              <th class="has-text-left " width="70%">
                ຄວາມຕ້ອງການ
              </th>
              <th class="has-text-right " width="20%">
                ຈຳນວນ
              </th>
            </tr>
          </thead>
          <tbody> 
            <tr
              v-for="(participaterank, index) in nexteventuptodigitalreport"
              :key="participaterank.NEXTEVENTUPTODIGITAL"
            > 
              <td> {{ index +1 }}</td>
              <td> {{ participaterank.NEXTEVENTUPTODIGITAL }}</td>
              <td class="has-text-right ">{{ participaterank.COUNTSCORE }}</td>
            </tr>
          </tbody>
          
        </table>

        <canvas id="nexteventuptodigitalreport" style="padding-left: 30px;"></canvas>
            
           
      </div>


    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
/* global Chart */

export default {
  data() {
    return {
      overallscorereport : [],
      overallscoredata: [],
      overallscoredatacount: [],

      provincereport : [],
      provincesdata: [],
      provincedatacount: [],
      
      numberofparticipatereport : [],
      numberofparticipatedata: [],
      numberofparticipatedatacount: [],

      durationreport : [],
      durationredata : [],
      durationredatacount : [],

      placescorereport : [], 
      placescoredata : [], 
      placescoredatacount : [], 

      activityscorereport : [], 
      activityscoredata : [], 
      activityscoredatacount : [], 

      coordinationscorereport : [],
      coordinationscoredata : [],
      coordinationscoredatacount : [],

      budgetreport : [],
      budgetdata : [],
      budgetdatacount : [],

      nexteventreport : [], 
      nexteventdata : [], 
      nexteventdatacount : [], 

      nexteventmonthreport : [], 
      nexteventmonthdata : [], 
      nexteventmonthdatacount : [], 

      nexteventuptodigitalreport : [], 
      nexteventuptodigitaldata : [], 
      nexteventuptodigitaldatacount : [], 
      
      provinceSwitch: 0,
      participateSwitch: 0,
      durationSwitch: 0,
      placescoreSwitch: 0,
      activityscoreSwitch: 0,  
      coordinationscoreSwitch: 0,
      budgetSwitch: 0,
      nexteventSwitch: 0,
      nexteventmonthSwitch: 0,
      nexteventuptodigitalSwitch : 0,
      overallscoreSwitch: 1,


      
    };
  },
  
  methods: {
   

    overallscoreDetail(){
      this.overallscoreSwitch = this.overallscoreSwitch == 1 ? 0 : 1 ;
    },

    provinceDetail(){
      this.provinceSwitch = this.provinceSwitch == 1 ? 0 : 1 ;
    },
    participateDetail(){
      this.participateSwitch = this.participateSwitch == 1 ? 0 : 1 ;
    },

    durationDetail(){
      this.durationSwitch = this.durationSwitch == 1 ? 0 : 1 ;
    },

    placescoreDetail(){
      this.placescoreSwitch = this.placescoreSwitch == 1 ? 0 : 1 ;
    },

    activityscoreDetail(){
      this.activityscoreSwitch = this.activityscoreSwitch == 1 ? 0 : 1 ;
    },

    coordinationscoreDetail(){
      this.coordinationscoreSwitch = this.coordinationscoreSwitch == 1 ? 0 : 1 ;
    },

    budgetDetail(){
      this.budgetSwitch = this.budgetSwitch == 1 ? 0 : 1 ;
    },

    nexteventDetail(){
      this.nexteventSwitch = this.nexteventSwitch == 1 ? 0 : 1 ;
    },

    nexteventmonthDetail(){
      this.nexteventmonthSwitch = this.nexteventmonthSwitch == 1 ? 0 : 1 ;
    },

    nexteventuptodigitalDetail(){
      this.nexteventuptodigitalSwitch = this.nexteventuptodigitalSwitch == 1 ? 0 : 1 ;
    },
    // Fetch data from the API
    getEventBoothSummaryReport() {
      RestAPI.getEventBoothSummaryReport()
        .then((res) => {
          // Assign data to the component's data properties
          
          this.provincereport = res.data.responseData.data.province;
          this.provincedata = this.provincereport.map(item => item.PROVINCENAME);
          this.provincedatacount = this.provincereport.map(item => item.COUNTSCORE);

          this.numberofparticipatereport = res.data.responseData.data.numberofparticipate;
          this.numberofparticipatedata= this.numberofparticipatereport.map(item => item.CUSTOMERRANK);
          this.numberofparticipatedatacount= this.numberofparticipatereport.map(item => item.COUNTRANK);

          this.overallscorereport = res.data.responseData.data.overallscore;
          this.overallscoredata= this.overallscorereport.map(item => item.OVERALLSCORE);
          this.overallscoredatacount = this.overallscorereport.map(item => item.COUNTSCORE);  




          this.durationreport = res.data.responseData.data.duration;
          this.durationdata= this.durationreport.map(item => item.DURATION);
          this.durationdatacount = this.durationreport.map(item => item.COUNTDURATION);  

          this.placescorereport = res.data.responseData.data.placescore;
          this.placescoredata= this.placescorereport.map(item => item.PLACESCORE);
          this.placescoredatacount = this.placescorereport.map(item => item.COUNTSCORE);  

          this.activityscorereport = res.data.responseData.data.activityscore;
          this.activityscoredata= this.activityscorereport.map(item => item.ACTIVITYSCORE);
          this.activityscoredatacount = this.activityscorereport.map(item => item.COUNTSCORE); 

          this.coordinationscorereport = res.data.responseData.data.coordinationscore;
          this.coordinationscoredata= this.coordinationscorereport.map(item => item.COORDINATIONSCORE);
          this.coordinationscoredatacount = this.coordinationscorereport.map(item => item.COUNTSCORE); 

          this.budgetreport = res.data.responseData.data.budget;
          this.budgetdata= this.budgetreport.map(item => item.BUDGET);
          this.budgetdatacount = this.budgetreport.map(item => item.COUNTSCORE); 

          this.nexteventreport = res.data.responseData.data.nextevent;
          this.nexteventdata= this.nexteventreport.map(item => item.NEXTEVENT);
          this.nexteventdatacount = this.nexteventreport.map(item => item.COUNTSCORE); 

          this.nexteventmonthreport = res.data.responseData.data.nexteventmonth;
          this.nexteventmonthdata= this.nexteventmonthreport.map(item => item.NEXTEVENTMONTH);
          this.nexteventmonthdatacount = this.nexteventmonthreport.map(item => item.COUNTSCORE); 

          this.nexteventuptodigitalreport = res.data.responseData.data.nexteventuptodigital;
          this.nexteventuptodigitaldata= this.nexteventuptodigitalreport.map(item => item.NEXTEVENTUPTODIGITAL);
          this.nexteventuptodigitaldatacount = this.nexteventuptodigitalreport.map(item => item.COUNTSCORE); 
          

          // After data is fetched, render the chart
          this.$nextTick(() => {
            this.renderChart("provincereport", this.provincedatacount, this.provincedata);
            this.renderChart("numberofparticipatereport", this.numberofparticipatedatacount, this.numberofparticipatedata);
            this.renderChart("overallscorereport", this.overallscoredatacount, this.overallscoredata);

            this.renderChart("durationreport", this.durationdatacount, this.durationdata);
            this.renderChart("placescorereport", this.placescoredatacount, this.placescoredata);
            this.renderChart("activityscorereport", this.activityscoredatacount, this.activityscoredata);
            this.renderChart("coordinationscorereport", this.coordinationscoredatacount, this.coordinationscoredata);
            this.renderChart("budgetreport", this.budgetdatacount, this.budgetdata);
            this.renderChart("nexteventreport", this.nexteventdatacount, this.nexteventdata);
            this.renderChart("nexteventmonthreport", this.nexteventmonthdatacount, this.nexteventmonthdata);
            this.renderChart("nexteventuptodigitalreport", this.nexteventuptodigitaldatacount, this.nexteventuptodigitaldata);
          });
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    // Generalized chart rendering function with parameters
    renderChart(canvasId, chartData, chartLabels) {
      const ctx = document.getElementById(canvasId).getContext("2d");

      const chartOptions = {
        type: "bar", // Bar chart is the default, can be parameterized
        data: {
          labels: chartLabels,
          datasets: [
            {
              label: "ແບບສອບຖາມ",
              data: chartData,
              backgroundColor: [
                "rgba(255, 99, 132, 0.6)",  // Darker shade of red
                "rgba(54, 162, 235, 0.6)",  // Darker shade of blue
                "rgba(255, 206, 86, 0.6)",  // Darker shade of yellow
                "rgba(75, 192, 192, 0.6)",  // Darker shade of cyan
                "rgba(153, 102, 255, 0.6)", // Darker shade of purple
                "rgba(255, 159, 64, 0.6)",  // Darker shade of orange
              ],
              borderColor: [
                "rgba(255, 99, 132, 1)",   // Darker red border
                "rgba(54, 162, 235, 1)",   // Darker blue border
                "rgba(255, 206, 86, 1)",   // Darker yellow border
                "rgba(75, 192, 192, 1)",   // Darker cyan border
                "rgba(153, 102, 255, 1)",  // Darker purple border
                "rgba(255, 159, 64, 1)",   // Darker orange border
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      };

      // Create a new Chart instance
      new Chart(ctx, chartOptions);
    },
  },

  mounted() {
    // Fetch data and render the chart
    this.getEventBoothSummaryReport();
  },
};
</script>
